<template>
    <div>
        <loading :active.sync="loading" :can-cancel="false" :is-full-page="true" :height="150" :width="150"
            :color="'#FFFF00'" :background-color="'#000000'" :opacity="0.5">
        </loading>
        <v-container>
            <v-form ref="form">
                <v-row>
                    <v-col>
                        <h2 class="pb-3">
                            {{ this.parentObject.pageTitle }}
                            <span class="page_title_value">
                                {{this.parentObject.pageTitleValue}}
                            </span>
                        </h2>
                    </v-col>
                </v-row>

                <v-card class="mt-n6">
                    <div class="ma-4">
                        <v-subheader class="blue--text">{{ $t('reportsparam.parameters') }}</v-subheader>
                        <v-row>
                            <v-col cols="4" sm="4" class="pb-n1">
                                <v-autocomplete outlined :label="this.$t('columns.company')" type="text" ref="company"
                                    v-model="formData.company" multiple dense :items="companyList" :rules="[rules.required]"
                                    clearable></v-autocomplete>
                            </v-col>
                            <v-col cols="6" sm="6" class="pb-n1">
                                <v-autocomplete outlined :label="this.$t('reportsparam.payout')" type="text" ref="payout"
                                    v-model="formData.payout" multiple dense :items="payoutList"
                                    clearable></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="1" sm="1" class="ml-4 mt-n8">
                                <p style="color: black; font-size: 14px;">{{ $t('payrollpivotreport.from') }} :</p>
                            </v-col>
                            <v-col cols="3" sm="3" class="mt-n8">
                                <v-autocomplete outlined :label="this.$t('reportsparam.year')" type="text"
                                    v-model="formData.yearFrom" hide-selected clearable :items="years"
                                    dense></v-autocomplete>
                            </v-col>
                            <v-col cols="3" sm="3" class="ml-2 mt-n8">
                                <v-autocomplete outlined :label="this.$t('reportsparam.month')" type="text"
                                    v-model="formData.monthFrom" hide-selected clearable :items="months"
                                    dense></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="1" sm="1" class="ml-4 mt-n8">
                                <p style="color: black; font-size: 14px;">{{ $t('payrollpivotreport.to') }} :</p>
                            </v-col>
                            <v-col cols="3" sm="3" class="mt-n8">
                                <v-autocomplete outlined :label="this.$t('reportsparam.year')" type="text"
                                    v-model="formData.yearTo" hide-selected clearable :items="years"
                                    dense></v-autocomplete>
                            </v-col>
                            <v-col cols="3" sm="3" class="ml-2 mt-n8">
                                <v-autocomplete outlined :label="this.$t('reportsparam.month')" type="text"
                                    v-model="formData.monthTo" hide-selected clearable :items="months"
                                    dense></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="2" sm="6" class="mt-n8">
                                <v-autocomplete outlined
                                    :label="this.$t('payrollsummaryanalysisreport.firstlevelgroupby')" type="text"
                                    ref="selectbykey1" hide-selected v-model="formData.selectbykey1" dense
                                    :items="selectby" clearable>
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="2" sm="6" class="mt-n8">
                                <v-autocomplete outlined :disabled="!formData.selectbykey1"
                                    :label="this.$t('payrollsummaryanalysisreport.secondlevelgroupby')" type="text"
                                    ref="selectbykey2" hide-selected v-model="formData.selectbykey2" dense
                                    :items="selectby" clearable>
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                    </div>
                </v-card>

                <v-expansion-panels class="mt-4">
                    <v-expansion-panel>
                        <v-expansion-panel-header class="blue--text">{{ $t('reportsparam.filtercriteria')
                        }}</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-row>
                                <v-col cols="4" sm="4" class="pb-4">
                                    <v-autocomplete outlined :label="this.$t('columns.staff')" type="text" ref="staff"
                                        v-model="formData.staff" multiple dense :items="staffList" clearable></v-autocomplete>
                                </v-col>

                                <v-col cols="4" sm="4" class="pb-4">
                                    <v-autocomplete outlined :label="this.$t('columns.division')" type="text"
                                        ref="division" v-model="formData.division" multiple dense :items="divisionList"
                                        clearable></v-autocomplete>
                                </v-col>

                                <v-col cols="4" sm="4" class="pb-4">
                                    <v-autocomplete outlined :label="this.$t('columns.grade')" type="text" ref="grade"
                                        v-model="formData.grade" multiple dense :items="gradeList" clearable></v-autocomplete>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                                    <v-autocomplete outlined :label="this.$t('columns.section')" type="text"
                                        ref="section" v-model="formData.section" multiple dense :items="sectionList"
                                        clearable></v-autocomplete>
                                </v-col>

                                <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                                    <v-autocomplete outlined :label="this.$t('columns.employmenttype')" type="text"
                                        ref="employmentType" v-model="formData.employmentType" multiple dense
                                        :items="emptypeList" clearable></v-autocomplete>
                                </v-col>

                                <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                                    <v-autocomplete outlined :label="this.$t('columns.branch')" type="text"
                                        ref="description" v-model="formData.branch" multiple dense :items="branchList"
                                        clearable></v-autocomplete>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                                    <v-autocomplete outlined :label="this.$t('columns.unit')" type="text" ref="unit"
                                        v-model="formData.unit" multiple dense :items="unitList" clearable></v-autocomplete>
                                </v-col>


                                <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                                    <v-autocomplete outlined :label="this.$t('columns.department')" type="text"
                                        ref="department" v-model="formData.department" multiple dense :items="departmentList"
                                        clearable></v-autocomplete>
                                </v-col>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>

                <v-row>
                    <v-col>
                        <v-btn color="warning" style="width: 100px; margin-top: 20px;" @click="goHandler">
                            {{$t('button.go') }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>
    </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export default {
    props: {
        parentObject: Object,
    },
    components: {
        Loading,
    },

    data() {
        return {
            rules: {
                required: (value) => !!value || this.$t('reportsparam.required'),
            },

            formData: {
                company: null,
                payout: null,
                yearFrom: null,
                monthFrom: null,
                yearTo: null,
                monthTo: null,
                selectbykey1: null,
                selectbykey2: null,

                staff: null,
                division: null,
                grade: null,
                section: null,
                employmentType: null,
                branch: null,
                unit: null,
                department: null,
            },

            selectby: [
                { text: this.$t('columns.branch'), value: 'branch' },
                { text: this.$t('columns.division'), value: 'division' },
                { text: this.$t('columns.department'), value: 'department' },
                { text: this.$t('columns.section'), value: 'section' },
                { text: this.$t('columns.unit'), value: 'unit' },
                { text: this.$t('columns.employmenttype'), value: 'employmentType' }
            ],

            userid: this.$store.getters.userId,
            username: this.$store.getters.userName,
            fileTitle:"Journal Summary",

            companies: [],
            companyList: [],
            payouts: [],
            payoutList: [],
            years: [],
            months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],

            staffs: [],
            staffList: [],
            divisions: [],
            divisionList: [],
            grades: [],
            gradeList: [],
            sections: [],
            sectionList: [],
            emptypes: [],
            emptypeList: [],
            branches: [],
            branchList: [],
            units: [],
            unitList: [],
            departments: [],
            departmentList: [],

            isErr: false,
            errMsg : null,
            loading: false,

            queryResult: null,
            queryResultGroupBy:null,

            staffSplitCode:false,
            //this is use to indicate whether the staffcode and staffname need to split
        };
    },

    methods: {

        loadYears() {
            for (let i = 2010; i < 2100; i++) {
                this.years.push(i);
            }
        },

        //load payouts
        loadPayoutsListHandler() {
            const vm = this;

            this.$store.dispatch('get', { url: "/payoutctrl/all" })
                .then((res) => {
                    vm.payouts = res.data.rec;
                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.payoutList.push({
                            text: res.data.rec[i].payoutcode,
                            value: res.data.rec[i].id,
                        });
                    }
                })
                .catch((err) => {
                    //error - unsucessfull request
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                });
        },

        //load staffs
        loadStaffListHandler() {
            const vm = this;

            this.$store.dispatch('get', { url: `/staff/all/${this.$store.getters.userId}` })
                .then((res) => {
                    vm.staffs = res.data.rec;
                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.staffList.push({
                            text:
                                res.data.rec[i].psnname +
                                " " +
                                res.data.rec[i].staffcode +
                                " " +
                                res.data.rec[i].compnyname,
                            value: res.data.rec[i].id,
                        });
                    }
                })
                .catch((err) => {
                    //error - unsucessfull request
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                });
        },

        //load divisions
        loadDivisionListHandler() {
            const vm = this;

            this.$store.dispatch('get', { url: "/division/all" })
                .then((res) => {
                    vm.divisions = res.data.rec;
                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.divisionList.push({
                            text: res.data.rec[i].divnname,
                            value: res.data.rec[i].id,
                        });
                    }
                })
                .catch((err) => {
                    //error - unsucessfull request
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                });
        },

        //load companies
        loadCompaniesListHandler() {
            const vm = this;

            this.$store.dispatch('get', { url: `/company/allfilter/${this.$store.getters.userId}` })//Only show company data that is valid to this user
                .then((res) => {
                    vm.companies = res.data.rec;

                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.companyList.push({
                            text: res.data.rec[i].compnyname,
                            value: res.data.rec[i].id,
                        });
                    }
                })
                .catch((err) => {
                    //error - unsucessfull request
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                });
        },

        //load section
        loadSectionListHandler() {
            const vm = this;

            this.$store.dispatch('get', { url: "/section/all" })
                .then((res) => {
                    vm.sections = res.data.rec;
                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.sectionList.push({
                            text: res.data.rec[i].sectioname,
                            value: res.data.rec[i].id,
                        });
                    }
                })
                .catch((err) => {
                    //error - unsucessfull request
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                });
        },

        //load emptypes
        loadEmpTypeListHandler() {
            const vm = this;

            this.$store.dispatch('get', { url: "/emptype/all" })
                .then((res) => {
                    vm.emptypes = res.data.rec;

                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.emptypeList.push({
                            text: res.data.rec[i].emptypedesc,
                            value: res.data.rec[i].id,
                        });
                    }
                })
                .catch((err) => {
                    //error - unsucessfull request
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                });
        },

        //load branches
        loadBanchListHandler() {
            const vm = this;

            this.$store.dispatch('get', { url: "/branch/all" })
                .then((res) => {
                    vm.branches = res.data.rec;

                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.branchList.push({
                            text: res.data.rec[i].brchname,
                            value: res.data.rec[i].id,
                        });
                    }
                })
                .catch((err) => {
                    //error - unsucessfull request
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                });
        },

        //load units
        loadUnitListHandler() {
            const vm = this;

            this.$store.dispatch('get', { url: "/unit/all" })
                .then((res) => {
                    vm.units = res.data.rec;

                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.unitList.push({
                            text: res.data.rec[i].unitname,
                            value: res.data.rec[i].id,
                        });
                    }
                })
                .catch((err) => {
                    //error - unsucessfull request
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                });
        },

        //load depts
        loadDeptListHandler() {
            const vm = this;

            this.$store.dispatch('get', { url: "/department/all" })
                .then((res) => {
                    vm.departments = res.data.rec;

                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.departmentList.push({
                            text: res.data.rec[i].deptname,
                            value: res.data.rec[i].id,
                        });
                    }
                })
                .catch((err) => {
                    //error - unsucessfull request
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                });
        },

        //load grades
        loadGradeListHandler() {
            const vm = this;

            this.$store.dispatch('get', { url: "/grade/all" })
                .then((res) => {
                    vm.grades = res.data.rec;

                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.gradeList.push({
                            text: res.data.rec[i].grddesc,
                            value: res.data.rec[i].id,
                        });
                    }
                })
                .catch((err) => {
                    //error - unsucessfull request
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                });
        },

        goHandler() {//this method is getting result from db
            this.loading = true;
            
            this.queryResult = null;//reset all reseult
            this.queryResultGroupBy = null;

            // Helper to check empty values (null, undefined, empty string or empty array)
            const isEmpty = val =>
                val === null || val === undefined ||
                (typeof val === 'string' && val.trim() === '') ||
                (Array.isArray(val) && val.length === 0);

            // Group-by value checks
            const validValues = this.selectby.map(item => item.value.toLowerCase());
            const normalize = val => typeof val === 'string' ? val.trim().toLowerCase() : '';

            const group1 = normalize(this.formData.selectbykey1);
            const group2 = normalize(this.formData.selectbykey2);

            const emitError = (msg) => {
                this.isErr = true;
                this.errMsg = msg;
                this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
                this.loading = false;
            };

            // 1. Group2 selected but Group1 empty
            if (group2 && !group1) {
                emitError("Please fill the first column first");
                return;
            }

            // 2. Duplicate group selection
            if (group1 && group2 && group1 === group2) {
                emitError("Cannot have 2 same group");
                return;
            }

            // 3. Invalid group names
            if ((group1 && !validValues.includes(group1)) || (group2 && !validValues.includes(group2))) {
                emitError("Invalid group by selection");
                return;
            }

            // 4. Date + Company/Payout validation
            const { monthFrom, monthTo, yearFrom, yearTo, company, payout } = this.formData;

            const dateFields = [monthFrom, monthTo, yearFrom, yearTo];
            const dateFilled = dateFields.filter(f => !isEmpty(f)).length;

            const hasAllDate = dateFilled === 4;
            const hasAnyDate = dateFilled > 0;

            // 5. Company must always be selected (array with values)
            if (!Array.isArray(company) || company.length === 0) {
                emitError("Please fill in the Company");
                return;
            }

            // 6. If partial date fields filled
            if (hasAnyDate && !hasAllDate) {
                emitError("Please fill in all Month and Year fields");
                return;
            }

            // 7. Must choose either Payout OR full Date — not both, not neither
            const hasPayout = Array.isArray(payout) && payout.length > 0;

            if (!hasAllDate && !hasPayout) {
                emitError("Please fill in either Payout or Month/Year fields");
                return;
            }

            if (hasAllDate && hasPayout) {
                emitError("Please fill in either Payout or Month/Year fields only, NOT both");
                return;
            }

            // 8. Date range logic (only if using all 4 date fields)
            if (hasAllDate) {
                const fromY = parseInt(yearFrom);
                const toY = parseInt(yearTo);
                const fromM = parseInt(monthFrom);
                const toM = parseInt(monthTo);

                if (
                    isNaN(fromY) || isNaN(toY) ||
                    isNaN(fromM) || isNaN(toM)
                ) {
                    emitError("Invalid numeric values in Month or Year");
                    return;
                }

                if (fromY > toY || (fromY === toY && fromM > toM)) {
                    emitError("Start Month/Year must not be after End Month/Year");
                    return;
                }
            }

            
            // ✅ Passed all validation
            //console.log("Valid formData:", this.formData);

            const url = hasAllDate
                ? `/payrollsummaryanalysis/date/${this.$store.getters.userId}`
                : `/payrollsummaryanalysis/payout/${this.$store.getters.userId}`;

            this.$store.dispatch('post', {
                url,
                payload: this.formData
            })
            .then(res => {
                this.queryResult = res.data.rec;
                this.processData();
            })
            .catch(err => {
                emitError(err?.message || "Unknown error occurred");
            });
        },

        processData() { //  recontruct the data
            const emitError = (msg) => {
                this.isErr = true;
                this.errMsg = msg;
                this.$emit("error", { isErr: true, errMsg: msg });
                this.loading = false;
            };

            if (!Array.isArray(this.queryResult) || this.queryResult.length === 0) {
                emitError("There is no result to export");
                return;
            }

            const { selectbykey1: groupKey1, selectbykey2: groupKey2 } = this.formData;
            const hasGrouping = !!groupKey1 || !!groupKey2;

            const keyToDescMap = {
                branch: { id: 'brchid', desc: 'brchdesc' },
                division: { id: 'divnid', desc: 'divdesc' },
                department: { id: 'deptid', desc: 'deptdesc' },
                section: { id: 'sectioid', desc: 'sectiodesc' },
                unit: { id: 'unitid', desc: 'unitdesc' },
                employmentType: { id: 'emptypeid', desc: 'emptypedesc' }
            };

            const toFixed = (val) => isNaN(val) ? '0.00' : Number(val).toFixed(2);
            const groupMap = new Map();

            for (const row of this.queryResult) {
                let groupKey = '', groupLabel = '', sortKey = [];
                let g1id = '', g1desc = '', g2id = '', g2desc = '';

                if (hasGrouping) {
                    this.staffSplitCode = false;
                    // At least one grouping selected
                    // Build group key and label
                    const g1 = keyToDescMap[groupKey1] || {};
                    const g2 = keyToDescMap[groupKey2] || {};

                    g1id = groupKey1 ? String(row[g1.id] ?? '0') : '';
                    g1desc = groupKey1 ? (row[g1.desc] ?? 'N/A') : '';

                    g2id = groupKey2 ? String(row[g2.id] ?? '0') : '';
                    g2desc = groupKey2 ? (row[g2.desc] ?? 'N/A') : '';

                    groupKey = `${g1id}_${g2id}`;
                    groupLabel = groupKey2 ? `${g1desc} / ${g2desc}` : g1desc;
                    sortKey = [g1id, g2id];
                } else {
                    this.staffSplitCode = true;
                    // No grouping selected, use staff as default group
                    // Then remember to split into 2 column in Excel
                    const staffid = String(row.staffid ?? '0');
                    const staffcode = row.staffcode ?? 'N/A';
                    const psnname = row.psnname ?? 'Unknown';

                    groupKey = staffid;
                    // groupLabel = `${psnname} - ${staffcode}`;
                    groupLabel = `${staffcode}staffcode:${psnname}`;
                    //i am using "staffcode:" to split it later on
                    sortKey = [staffid];
                }

                if (!groupMap.has(groupKey)) {
                    groupMap.set(groupKey, {
                        groupName: groupLabel,
                        sortKey,
                        grosspay: 0,
                        netpay: 0,
                        _salhdIds: new Set(),
                        payitemSummary: {}
                    });
                }

                const group = groupMap.get(groupKey);

                // ✅ Prevent gross/net duplication due to LEFT JOIN (based on salhd.id)
                const salhdId = row.id ?? '';
                if (!group._salhdIds.has(salhdId)) {
                    group.grosspay += Number(row.grosspay || 0);
                    group.netpay += Number(row.netpay || 0);
                    group._salhdIds.add(salhdId);
                }

                // Build payitem structure
                const catid = Number(row.payitemcatid ?? 0);
                const catdesc = row.payitemcatdesc ?? 'Unknown Category';
                const typeid = Number(row.payitemtypeid ?? 0);
                const typedesc = row.payitemtypedesc ?? 'Unknown Type';
                const itemid = Number(row.payitemid ?? 0);
                const itemdesc = row.payitemdesc ?? 'Unknown Item';

                if (!group.payitemSummary[catid]) {
                    group.payitemSummary[catid] = { desc: catdesc, types: {} };
                }
                if (!group.payitemSummary[catid].types[typeid]) {
                    group.payitemSummary[catid].types[typeid] = { desc: typedesc, items: {} };
                }
                if (!group.payitemSummary[catid].types[typeid].items[itemid]) {
                    group.payitemSummary[catid].types[typeid].items[itemid] = {
                        payitemid: itemid,
                        payitemdesc: itemdesc,
                        aprvamt: 0
                    };
                }

                group.payitemSummary[catid].types[typeid].items[itemid].aprvamt += Number(row.aprvamt || 0);
            }

            const groupedSorted = Array.from(groupMap.values())
                .map(g => {
                    // Clean up private tracking before export
                    delete g._salhdIds;
                    return g;
                })
                .sort((a, b) => a.sortKey.join('_').localeCompare(b.sortKey.join('_')));

            // Final structure to be used in CSV export or display
            this.queryResultGroupBy = groupedSorted.map(group => ({
                groupName: group.groupName,
                grosspay: toFixed(group.grosspay),
                netpay: toFixed(group.netpay),
                payitems: Object.entries(group.payitemSummary).map(([catid, cat]) => ({
                    payitemcatid: catid,
                    payitemcatdesc: cat.desc,
                    types: Object.entries(cat.types).map(([typeid, type]) => ({
                        payitemtypeid: typeid,
                        payitemtypedesc: type.desc,
                        items: Object.values(type.items).map(item => ({
                            payitemid: item.payitemid,
                            payitemdesc: item.payitemdesc,
                            aprvamt: toFixed(item.aprvamt)
                        }))
                    }))
                }))
            }));

            //console.log("Query Result", this.queryResult);
            //console.log("Processed for export:", this.queryResultGroupBy);

            if(this.staffSplitCode){//sort by staffcode
                this.queryResultGroupBy.sort((a, b) => {
                    return a.groupName.localeCompare(b.groupName);
                });
            }
            //this.exportToCSV(); // now we only call download to XLSX format, the default excel format
            this.exportToXLSX();
        },

        // exportToCSV() { // this method is not used, as we export to xlsx, not updated also
        //     const emitError = (msg) => {
        //         this.isErr = true;
        //         this.errMsg = msg;
        //         this.$emit("error", { isErr: true, errMsg: msg });
        //         this.loading = false;
        //     };

        //     if (!this.queryResultGroupBy || this.queryResultGroupBy.length === 0) {
        //         emitError("There is no result to export In CSV");
        //         return;
        //     }

        //     const toFixed = val => isNaN(val) ? '0.00' : Number(val).toFixed(2);
        //     const escapeCSV = value => typeof value !== 'string' ? value : `"${value.replace(/"/g, '""')}"`;

        //     const selectedCompanies = this.formData.company || [];
        //     const matchedCompanies = this.companyList.filter(c => selectedCompanies.includes(c.value)).map(c => c.text);
        //     const companyName = matchedCompanies.length > 0 ? matchedCompanies.join(', ') : 'Unknown Company';

        //     const { yearFrom, monthFrom, yearTo, monthTo } = this.formData;
        //     const isValidRange = yearFrom && monthFrom && yearTo && monthTo;

        //     //const currentTime = new Date().toLocaleString();
        //     const now = new Date();
        //     const day = now.getDate().toString().padStart(2, '0'); // 01, 02, etc.
        //     const month = now.toLocaleString('en-GB', { month: 'long' }); // August
        //     const year = now.getFullYear();
        //     const time = now.toLocaleTimeString('en-US', { hour12: true }); // 02:37:52 PM

        //     const currentTime = `${day} ${month} ${year} ${time}`;

        //     const descList = (this.queryResult || []).map(row => row.payoutdesc).filter(desc => !!desc);
        //     const payoutDesc = [...new Set(descList)].join(', ') || 'Unknown Payout';

        //     const printedBy = this.username || 'Unknown User';
        //     const csv = [];

        //     // --- Metadata Rows ---
        //     csv.push([], []);
        //     csv.push(["Company Name:", escapeCSV(companyName)]);

        //     if (isValidRange) {
        //         const fromDate = new Date(yearFrom, monthFrom - 1);
        //         const toDate = new Date(yearTo, monthTo - 1);
        //         const fromLabel = fromDate.toLocaleString('default', { month: 'long', year: 'numeric' });
        //         const toLabel = toDate.toLocaleString('default', { month: 'long', year: 'numeric' });
        //         const dateRange = (fromDate.getFullYear() === toDate.getFullYear() && fromDate.getMonth() === toDate.getMonth()) ? fromLabel : `${fromLabel} to ${toLabel}`;
        //         csv.push(["Year/Month:", escapeCSV(dateRange)]);
        //     }

        //     csv.push(["Payout Description:", escapeCSV(payoutDesc)]);
        //     csv.push(["Date Time:", escapeCSV(currentTime)]);
        //     csv.push(["Printed by:", escapeCSV(printedBy)]);
        //     csv.push([], []);

        //     const selectbyMap = {
        //         branch: this.$t('columns.branch'),
        //         division: this.$t('columns.division'),
        //         department: this.$t('columns.department'),
        //         section: this.$t('columns.section'),
        //         unit: this.$t('columns.unit'),
        //         employmentType: this.$t('columns.employmenttype')
        //     };

        //     let groupNameToShow = "Staff Name - Staff Code";
        //     if (this.formData.selectbykey1 && this.formData.selectbykey2) {
        //         const label1 = selectbyMap[this.formData.selectbykey1] || this.formData.selectbykey1;
        //         const label2 = selectbyMap[this.formData.selectbykey2] || this.formData.selectbykey2;
        //         groupNameToShow = `${label1} / ${label2}`;
        //     } else if (this.formData.selectbykey1) {
        //         groupNameToShow = selectbyMap[this.formData.selectbykey1] || this.formData.selectbykey1;
        //     }

        //     //:Warning , hardcoded sorting, 
        //     // Basic - Allowance - Overtime - Reimbursement - Bonus - Deduction - STATUTORY - NON-PAYABLE - NON-DEDUCTABLE
        //     const customCatOrder = [1, 3, 5, 6, 2, 4, 7, 8, 9];
        //     const catOrderMap = new Map();
        //     customCatOrder.forEach((catId, index) => catOrderMap.set(catId, index));

        //     const seenKeys = new Set();
        //     const payitemHierarchy = [];

        //     this.queryResultGroupBy.forEach(group => {
        //         group.payitems.forEach(cat => {
        //             cat.types.forEach(type => {
        //                 type.items.forEach(item => {
        //                     const key = `${cat.payitemcatdesc}|${type.payitemtypedesc}|${item.payitemdesc}`;
        //                     if (!seenKeys.has(key)) {
        //                         seenKeys.add(key);
        //                         payitemHierarchy.push({
        //                             catId: Number(cat.payitemcatid),
        //                             typeId: Number(type.payitemtypeid),
        //                             itemId: Number(item.payitemid),
        //                             cat: cat.payitemcatdesc,
        //                             type: type.payitemtypedesc,
        //                             item: item.payitemdesc,
        //                             key
        //                         });
        //                     }
        //                 });
        //             });
        //         });
        //     });

        //     payitemHierarchy.sort((a, b) => {
        //         const aPriority = catOrderMap.has(a.catId) ? catOrderMap.get(a.catId) : Infinity;
        //         const bPriority = catOrderMap.has(b.catId) ? catOrderMap.get(b.catId) : Infinity;
        //         if (aPriority !== bPriority) return aPriority - bPriority;
        //         if (a.typeId !== b.typeId) return a.typeId - b.typeId;
        //         return a.itemId - b.itemId;
        //     });

        //     const grossKey = `Gross Pay|Gross Pay|Gross Pay`;
        //     const netKey = `Net Pay|Net Pay|Net Pay`;

        //     const grossItem = { catId: 99991, typeId: 99991, itemId: 99991, cat: 'Gross Pay', type: 'Gross Pay', item: 'Gross Pay', key: grossKey };
        //     const netItem = { catId: 99992, typeId: 99992, itemId: 99992, cat: 'Net Pay', type: 'Net Pay', item: 'Net Pay', key: netKey };

        //     //:Warning , hardcoded to insert after all positive value
        //     const insertGrossIndex = (() => {
        //         const preferredCatIds = [2, 6, 5, 3, 1];
        //         for (const catId of preferredCatIds) {
        //             const indexes = payitemHierarchy.map((h, i) => h.catId === catId ? i : -1).filter(i => i !== -1);
        //             if (indexes.length) return Math.max(...indexes) + 1;
        //         }
        //         return payitemHierarchy.length;
        //     })();

        //     payitemHierarchy.splice(insertGrossIndex, 0, grossItem);

        //     /*
        //     //::Backup of insert index logic
        //     const insertNetIndex = (() => {
        //         const indexes = payitemHierarchy.map((h, i) => h.typeId === 12 ? i : -1).filter(i => i !== -1);
        //         return indexes.length ? Math.max(...indexes) + 1 : payitemHierarchy.length;
        //     })();

        //     //Since gross was inserted already, it may have shifted indices
        //     const finalNetIndex = insertNetIndex >= insertGrossIndex ? insertNetIndex : insertNetIndex;
        //     payitemHierarchy.splice(finalNetIndex, 0, netItem);
        //     */

        //     //:warning, hardcoded to insert after staff staturory or before company stat, not found then last
        //     const insertNetIndex = (() => {
        //         const type12Indexes = payitemHierarchy
        //             .map((h, i) => h.typeId === 12 ? i : -1)
        //             .filter(i => i !== -1);

        //         if (type12Indexes.length) {
        //             // Found typeId = 12, insert after the last one
        //             return Math.max(...type12Indexes) + 1;
        //         }

        //         const type13Index = payitemHierarchy.findIndex(h => h.typeId === 13);
        //         if (type13Index !== -1) {
        //             // Found typeId = 13, insert before first type13
        //             return type13Index;
        //         }

        //         // Neither 12 nor 13 found, insert at the end
        //         return payitemHierarchy.length;
        //     })();

        //     payitemHierarchy.splice(insertNetIndex, 0, netItem);

        //     const columnKeys = payitemHierarchy.map(h => h.key);

        //     csv.push([]);
        //     /* //Detail Header
        //     csv.push(['#', groupNameToShow, ...payitemHierarchy.map(h => h.cat)]);
        //     csv.push(['', '', ...payitemHierarchy.map(h => h.type)]);
        //     csv.push(['', '', ...payitemHierarchy.map(h => h.item)]);
        //     */
        //     csv.push(['#', groupNameToShow, ...payitemHierarchy.map(h => h.item)]);

        //     let rowCount = 0;
        //     const totals = Array(columnKeys.length).fill(0);

        //     this.queryResultGroupBy.forEach(group => {
        //         rowCount++;
        //         const row = [rowCount, group.groupName];
        //         const itemMap = new Map();

        //         group.payitems.forEach(cat => {
        //             cat.types.forEach(type => {
        //                 type.items.forEach(item => {
        //                     const key = `${cat.payitemcatdesc}|${type.payitemtypedesc}|${item.payitemdesc}`;
        //                     itemMap.set(key, Number(item.aprvamt || 0));
        //                 });
        //             });
        //         });

        //         columnKeys.forEach((key, i) => {
        //             let val = 0;
        //             if (key === grossKey) val = Number(group.grosspay || 0);
        //             else if (key === netKey) val = Number(group.netpay || 0);
        //             else val = itemMap.get(key) || 0;
        //             row.push(toFixed(val));
        //             totals[i] += val;
        //         });

        //         csv.push(row);
        //     });

        //     csv.push([], []);
        //     csv.push(['Total', '', ...totals.map(toFixed)]);

        //     const csvContent = csv.map(row => row.join(',')).join('\n');
        //     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        //     const url = URL.createObjectURL(blob);
        //     const link = document.createElement('a');
        //     link.href = url;
        //     link.setAttribute('download', `${this.fileTitle}.csv`);
        //     document.body.appendChild(link);
        //     link.click();
        //     document.body.removeChild(link);

        //     this.loading = false;
        // },

        // exportToXLSX() {//this method pass value as string, so elminated
        //     const emitError = (msg) => {
        //         this.isErr = true;
        //         this.errMsg = msg;
        //         this.$emit("error", { isErr: true, errMsg: msg });
        //         this.loading = false;
        //     };

        //     if (!this.queryResultGroupBy || this.queryResultGroupBy.length === 0) {
        //         emitError("There is no result to export in XLSX");
        //         return;
        //     }

        //     const toFixed = val => isNaN(val) ? '0.00' : Number(val).toFixed(2);

        //     const selectedCompanies = this.formData.company || [];
        //     const matchedCompanies = this.companyList.filter(c => selectedCompanies.includes(c.value)).map(c => c.text);
        //     const companyName = matchedCompanies.length > 0 ? matchedCompanies.join(', ') : 'Unknown Company';

        //     const { yearFrom, monthFrom, yearTo, monthTo } = this.formData;
        //     const isValidRange = yearFrom && monthFrom && yearTo && monthTo;

        //     //const currentTime = new Date().toLocaleString();
        //     const now = new Date();
        //     const day = now.getDate().toString().padStart(2, '0'); // 01, 02, etc.
        //     const month = now.toLocaleString('en-GB', { month: 'long' }); // August
        //     const year = now.getFullYear();
        //     const time = now.toLocaleTimeString('en-US', { hour12: true }); // 02:37:52 PM

        //     const currentTime = `${day} ${month} ${year} ${time}`;

        //     const descList = (this.queryResult || []).map(row => row.payoutdesc).filter(desc => !!desc);
        //     const payoutDesc = [...new Set(descList)].join(', ') || 'Unknown Payout';

        //     const printedBy = this.username || 'Unknown User';

        //     const data = [];
        //     data.push([]);
        //     data.push(["Company Name:", companyName]);

        //     if (isValidRange) {
        //         const fromDate = new Date(yearFrom, monthFrom - 1);
        //         const toDate = new Date(yearTo, monthTo - 1);
        //         const fromLabel = fromDate.toLocaleString('default', { month: 'long', year: 'numeric' });
        //         const toLabel = toDate.toLocaleString('default', { month: 'long', year: 'numeric' });
        //         const dateRange = (fromDate.getFullYear() === toDate.getFullYear() && fromDate.getMonth() === toDate.getMonth()) ? fromLabel : `${fromLabel} to ${toLabel}`;
        //         data.push(["Year/Month:", dateRange]);
        //     }

        //     data.push(["Payout Description:", payoutDesc]);
        //     data.push(["Date Time:", currentTime]);
        //     data.push(["Printed by:", printedBy]);
        //     data.push([]);
        //     data.push([]);

        //     //:Warning , hardcoded sorting, 
        //     // Basic - Allowance - Overtime - Reimbursement - Bonus - Deduction - STATUTORY - NON-PAYABLE - NON-DEDUCTABLE
        //     const customCatOrder = [1, 3, 5, 6, 2, 4, 7, 8, 9];
        //     const catOrderMap = new Map();
        //     customCatOrder.forEach((catId, index) => catOrderMap.set(catId, index));

        //     const seenKeys = new Set();
        //     const payitemHierarchy = [];

        //     this.queryResultGroupBy.forEach(group => {
        //         group.payitems.forEach(cat => {
        //             cat.types.forEach(type => {
        //                 type.items.forEach(item => {
        //                     const key = `${cat.payitemcatdesc}|${type.payitemtypedesc}|${item.payitemdesc}`;
        //                     if (!seenKeys.has(key)) {
        //                         seenKeys.add(key);
        //                         payitemHierarchy.push({
        //                             catId: Number(cat.payitemcatid),
        //                             typeId: Number(type.payitemtypeid),
        //                             itemId: Number(item.payitemid),
        //                             cat: cat.payitemcatdesc,
        //                             type: type.payitemtypedesc,
        //                             item: item.payitemdesc,
        //                             key
        //                         });
        //                     }
        //                 });
        //             });
        //         });
        //     });

        //     payitemHierarchy.sort((a, b) => {
        //         const aPriority = catOrderMap.has(a.catId) ? catOrderMap.get(a.catId) : Infinity;
        //         const bPriority = catOrderMap.has(b.catId) ? catOrderMap.get(b.catId) : Infinity;
        //         if (aPriority !== bPriority) return aPriority - bPriority;
        //         if (a.typeId !== b.typeId) return a.typeId - b.typeId;
        //         return a.itemId - b.itemId;
        //     });

        //     const grossKey = `Gross Pay|Gross Pay|Gross Pay`;
        //     const netKey = `Net Pay|Net Pay|Net Pay`;

        //     const grossItem = { catId: 99991, typeId: 99991, itemId: 99991, cat: 'Gross Pay', type: 'Gross Pay', item: 'Gross Pay', key: grossKey };
        //     const netItem = { catId: 99992, typeId: 99992, itemId: 99992, cat: 'Net Pay', type: 'Net Pay', item: 'Net Pay', key: netKey };

        //     //:Warning , hardcoded to insert after all positive value
        //     const insertGrossIndex = (() => {
        //         const preferredCatIds = [2, 6, 5, 3, 1];
        //         for (const catId of preferredCatIds) {
        //             const indexes = payitemHierarchy.map((h, i) => h.catId === catId ? i : -1).filter(i => i !== -1);
        //             if (indexes.length) return Math.max(...indexes) + 1;
        //         }
        //         return payitemHierarchy.length;
        //     })();

        //     payitemHierarchy.splice(insertGrossIndex, 0, grossItem);

        //     //:warning, hardcoded to insert after staff staturory or before company stat, not found then last
        //     const insertNetIndex = (() => {
        //         const type12Indexes = payitemHierarchy.map((h, i) => h.typeId === 12 ? i : -1).filter(i => i !== -1);
        //         if (type12Indexes.length) return Math.max(...type12Indexes) + 1;

        //         const type13Index = payitemHierarchy.findIndex(h => h.typeId === 13);
        //         if (type13Index !== -1) return type13Index;

        //         return payitemHierarchy.length;
        //     })();

        //     payitemHierarchy.splice(insertNetIndex, 0, netItem);

        //     const columnKeys = payitemHierarchy.map(h => h.key);

        //     data.push(['#', 'Group Name', ...payitemHierarchy.map(h => h.item)]);

        //     let rowCount = 0;
        //     const totals = Array(columnKeys.length).fill(0);

        //     this.queryResultGroupBy.forEach(group => {
        //         rowCount++;
        //         const row = [rowCount, group.groupName];
        //         const itemMap = new Map();

        //         group.payitems.forEach(cat => {
        //             cat.types.forEach(type => {
        //                 type.items.forEach(item => {
        //                     const key = `${cat.payitemcatdesc}|${type.payitemtypedesc}|${item.payitemdesc}`;
        //                     itemMap.set(key, Number(item.aprvamt || 0));
        //                 });
        //             });
        //         });

        //         columnKeys.forEach((key, i) => {
        //             let val = 0;
        //             if (key === grossKey) val = Number(group.grosspay || 0);
        //             else if (key === netKey) val = Number(group.netpay || 0);
        //             else val = itemMap.get(key) || 0;
        //             row.push(toFixed(val));
        //             totals[i] += val;
        //         });

        //         data.push(row);
        //     });

        //     data.push([]);
        //     data.push(['Total', '', ...totals.map(toFixed)]);

        //     // XLSX export
        //     const worksheet = XLSX.utils.aoa_to_sheet(data);
        //     const workbook = XLSX.utils.book_new();
        //     XLSX.utils.book_append_sheet(workbook, worksheet, 'Payout Summary');

        //     const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        //     const blob = new Blob([wbout], { type: 'application/octet-stream' });
        //     const filename = `${this.fileTitle || 'Payout Export'}.xlsx`;

        //     saveAs(blob, filename);

        //     this.loading = false;
        // },

        exportToXLSX() {
            const emitError = (msg) => {
                this.isErr = true;
                this.errMsg = msg;
                this.$emit("error", { isErr: true, errMsg: msg });
                this.loading = false;
            };

            if (!this.queryResultGroupBy || this.queryResultGroupBy.length === 0) {
                emitError("There is no result to export in XLSX");
                return;
            }

            // ✅ keep as number instead of string
            const toFixedNum = val => isNaN(val) ? 0.00 : Number(Number(val).toFixed(2));

            const selectedCompanies = this.formData.company || [];
            const matchedCompanies = this.companyList.filter(c => selectedCompanies.includes(c.value)).map(c => c.text);
            const companyName = matchedCompanies.length > 0 ? matchedCompanies.join(', ') : 'Unknown Company';

            const { yearFrom, monthFrom, yearTo, monthTo } = this.formData;
            const isValidRange = yearFrom && monthFrom && yearTo && monthTo;

            // Format DateTime: DD Month YYYY hh:mm:ss AM/PM
            const now = new Date();
            const day = now.getDate().toString().padStart(2, '0');
            const month = now.toLocaleString('en-GB', { month: 'long' });
            const year = now.getFullYear();
            const time = now.toLocaleTimeString('en-US', { hour12: true });
            const currentTime = `${day} ${month} ${year} ${time}`;

            const descList = (this.queryResult || []).map(row => row.payoutdesc).filter(desc => !!desc);
            const payoutDesc = [...new Set(descList)].join(', ') || 'Unknown Payout';

            const printedBy = this.username || 'Unknown User';

            const data = [];
            data.push([]);
            data.push(["Company Name:", companyName]);

            if (isValidRange) {
                const fromDate = new Date(yearFrom, monthFrom - 1);
                const toDate = new Date(yearTo, monthTo - 1);
                const fromLabel = fromDate.toLocaleString('default', { month: 'long', year: 'numeric' });
                const toLabel = toDate.toLocaleString('default', { month: 'long', year: 'numeric' });
                const dateRange = (fromDate.getFullYear() === toDate.getFullYear() && fromDate.getMonth() === toDate.getMonth()) ? fromLabel : `${fromLabel} to ${toLabel}`;
                data.push(["Year/Month:", dateRange]);
            }

            data.push(["Payout Description:", payoutDesc]);
            data.push(["Date Time:", currentTime]);
            data.push(["Printed by:", printedBy]);
            data.push([]);
            data.push([]);

            // --- Sorting Logic ---
            const customCatOrder = [1, 3, 5, 6, 2, 4, 7, 8, 9];
            const catOrderMap = new Map();
            customCatOrder.forEach((catId, index) => catOrderMap.set(catId, index));

            const seenKeys = new Set();
            const payitemHierarchy = [];

            this.queryResultGroupBy.forEach(group => {
                group.payitems.forEach(cat => {
                    cat.types.forEach(type => {
                        type.items.forEach(item => {
                            const key = `${cat.payitemcatdesc}|${type.payitemtypedesc}|${item.payitemdesc}`;
                            if (!seenKeys.has(key)) {
                                seenKeys.add(key);
                                payitemHierarchy.push({
                                    catId: Number(cat.payitemcatid),
                                    typeId: Number(type.payitemtypeid),
                                    itemId: Number(item.payitemid),
                                    cat: cat.payitemcatdesc,
                                    type: type.payitemtypedesc,
                                    item: item.payitemdesc,
                                    key
                                });
                            }
                        });
                    });
                });
            });

            payitemHierarchy.sort((a, b) => {
                const aPriority = catOrderMap.has(a.catId) ? catOrderMap.get(a.catId) : Infinity;
                const bPriority = catOrderMap.has(b.catId) ? catOrderMap.get(b.catId) : Infinity;
                if (aPriority !== bPriority) return aPriority - bPriority;
                if (a.typeId !== b.typeId) return a.typeId - b.typeId;
                return a.itemId - b.itemId;
            });

            const grossKey = `Gross Pay|Gross Pay|Gross Pay`;
            const netKey = `Net Pay|Net Pay|Net Pay`;

            const grossItem = { catId: 99991, typeId: 99991, itemId: 99991, cat: 'Gross Pay', type: 'Gross Pay', item: 'Gross Pay', key: grossKey };
            const netItem = { catId: 99992, typeId: 99992, itemId: 99992, cat: 'Net Pay', type: 'Net Pay', item: 'Net Pay', key: netKey };

            // Insert Gross Pay
            const insertGrossIndex = (() => {
                const preferredCatIds = [2, 6, 5, 3, 1];
                for (const catId of preferredCatIds) {
                    const indexes = payitemHierarchy.map((h, i) => h.catId === catId ? i : -1).filter(i => i !== -1);
                    if (indexes.length) return Math.max(...indexes) + 1;
                }
                return payitemHierarchy.length;
            })();
            payitemHierarchy.splice(insertGrossIndex, 0, grossItem);

            // Insert Net Pay
            const insertNetIndex = (() => {
                const type12Indexes = payitemHierarchy.map((h, i) => h.typeId === 12 ? i : -1).filter(i => i !== -1);
                if (type12Indexes.length) return Math.max(...type12Indexes) + 1;
                const type13Index = payitemHierarchy.findIndex(h => h.typeId === 13);
                if (type13Index !== -1) return type13Index;
                return payitemHierarchy.length;
            })();
            payitemHierarchy.splice(insertNetIndex, 0, netItem);

            const columnKeys = payitemHierarchy.map(h => h.key);

            if(this.staffSplitCode){
                data.push(['#', 'Staff Code', 'Staff Name', ...payitemHierarchy.map(h => h.item)]);
            }else{
                data.push(['#', 'Group Name', ...payitemHierarchy.map(h => h.item)]);
            }
           
            let rowCount = 0;
            const totals = Array(columnKeys.length).fill(0);

            this.queryResultGroupBy.forEach(group => {
                rowCount++;
                const row = [];
                if(this.staffSplitCode){
                    const [staffCode,staffName] = group.groupName.split('staffcode:');
                    row.push(rowCount, staffCode || '', staffName || '');
                }else{
                    row.push(rowCount, group.groupName);
                }
               
                const itemMap = new Map();

                group.payitems.forEach(cat => {
                    cat.types.forEach(type => {
                        type.items.forEach(item => {
                            const key = `${cat.payitemcatdesc}|${type.payitemtypedesc}|${item.payitemdesc}`;
                            itemMap.set(key, Number(item.aprvamt || 0));
                        });
                    });
                });

                columnKeys.forEach((key, i) => {
                    let val = 0;
                    if (key === grossKey) val = Number(group.grosspay || 0);
                    else if (key === netKey) val = Number(group.netpay || 0);
                    else val = itemMap.get(key) || 0;
                    const numVal = toFixedNum(val);   // ✅ number, not string
                    row.push(numVal);
                    totals[i] += numVal;
                });

                data.push(row);
            });

            data.push([]);
            if(this.staffSplitCode){
                data.push(['Total', '', '', ...totals.map(toFixedNum)]);
                //double column for staff code and name
            }else{
                data.push(['Total', '', ...totals.map(toFixedNum)]);
            }

            // Build Excel Sheet
            const worksheet = XLSX.utils.aoa_to_sheet(data);

            // ✅ Apply number formatting for all numeric cells
            const range = XLSX.utils.decode_range(worksheet['!ref']);
            for (let R = 2; R <= range.e.r; R++) {   // skip metadata rows
                for (let C = 2; C <= range.e.c; C++) { // start from column C (index 2)
                    const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
                    const cell = worksheet[cellRef];
                    if (cell && typeof cell.v === 'number') {
                        cell.t = 'n';    // mark as number
                        cell.z = '0.00'; // format to 2 decimals
                    }
                }
            }

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Payout Summary');

            const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([wbout], { type: 'application/octet-stream' });
            const filename = `${this.fileTitle || 'Payout Export'}.xlsx`;

            saveAs(blob, filename);
            this.loading = false;
        },

    },//end of method
    mounted() {
        this.loading= true;

        this.loadYears();
        this.loadPayoutsListHandler();
        this.loadCompaniesListHandler();

        this.loadStaffListHandler();
        this.loadGradeListHandler();
        this.loadDeptListHandler();
        this.loadUnitListHandler();
        this.loadBanchListHandler();
        this.loadEmpTypeListHandler();
        this.loadSectionListHandler();
        this.loadDivisionListHandler();

        this.loading= false;
    },
};
</script>

<style lang="scss" scoped>
.v-subheader {
    padding: 0px !important;
}
</style>